import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Honeypot, RgpdCheckbox } from "./ReservationForm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls = "w-full rounded-lg border border-terracotta/25 bg-white px-4 py-3 text-encre placeholder:text-taupe/60 focus:outline-none focus:ring-2 focus:ring-terracotta/50";
const labelCls = "block text-sm font-semibold text-encre mb-1.5";

export const ContactForm = () => {
  const navigate = useNavigate();
  const [sending, setSending] = useState(false);
  const [form, setForm] = useState({ nom: "", email: "", telephone: "", sujet: "", message: "", rgpd: false, website: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const payload = { ...form, telephone: form.telephone || null };
      const { data } = await axios.post(`${API}/contact`, payload);
      toast.success(data.message);
      navigate("/merci?type=contact");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Une erreur est survenue. Veuillez réessayer ou nous appeler au 07 75 77 29 51.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="contact-form">
      <Honeypot value={form.website} onChange={set("website")} />
      <div className="grid sm:grid-cols-2 gap-5">
        <div>
          <label htmlFor="ct-nom" className={labelCls}>Nom et prénom *</label>
          <input id="ct-nom" data-testid="contact-nom" required className={inputCls} value={form.nom} onChange={set("nom")} autoComplete="name" />
        </div>
        <div>
          <label htmlFor="ct-email" className={labelCls}>Email *</label>
          <input id="ct-email" data-testid="contact-email" type="email" required className={inputCls} value={form.email} onChange={set("email")} autoComplete="email" />
        </div>
        <div>
          <label htmlFor="ct-tel" className={labelCls}>Téléphone (facultatif)</label>
          <input id="ct-tel" data-testid="contact-telephone" type="tel" className={inputCls} value={form.telephone} onChange={set("telephone")} autoComplete="tel" />
        </div>
        <div>
          <label htmlFor="ct-sujet" className={labelCls}>Sujet *</label>
          <input id="ct-sujet" data-testid="contact-sujet" required className={inputCls} value={form.sujet} onChange={set("sujet")} />
        </div>
      </div>
      <div>
        <label htmlFor="ct-message" className={labelCls}>Message * (20 caractères minimum)</label>
        <textarea id="ct-message" data-testid="contact-message" required minLength={20} rows="5" className={inputCls} value={form.message} onChange={set("message")} />
      </div>
      <RgpdCheckbox checked={form.rgpd} onChange={set("rgpd")} idPrefix="contact" />
      <button
        type="submit"
        data-testid="contact-submit"
        disabled={sending}
        className="rounded-full bg-terracotta text-cream px-8 py-3.5 font-semibold transition-all duration-300 hover:bg-terracotta-dark hover:shadow-lg disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {sending ? "Envoi en cours…" : "Envoyer le message"}
      </button>
    </form>
  );
};
